import React, { useMemo, useRef } from "react";
import { Group, Rect, Text } from "react-konva";
import Konva from "konva";
import { IMondayTaskController, FileColumn } from "../../controller";
import { FONT_SIZE, FONT_FAMILY } from "../../consts";
import { measureTextWidth } from "../../text-utils";
import { KonvaTooltip } from "frontend/ui-components/design-system/tooltip/konva-tooltip";
import { DownloadButton } from "./download-button";
import { VisibilityButton } from "./visibility-button";

const TEXT_COLOR = "#7F869B";

interface FileRowProps {
  file: FileColumn["value"][0] & { hidden: boolean };
  controller: IMondayTaskController;
  y: number;
  maxFileNameWidth: number;
}

export const FileRow = React.memo(({ file, controller, y, maxFileNameWidth }: FileRowProps) => {
  const { isImage } = file;
  const tooltipNode = useRef<Konva.Rect | null>(null);

  let width = maxFileNameWidth - 32 - 16; // Width accounting for padding and download button
  if (isImage) {
    width -= 20; //Visibility button
  }

  const isTruncated = useMemo(() => {
    const { isTruncated } = measureTextWidth(file.name, {
      fontSize: FONT_SIZE,
      fontFamily: FONT_FAMILY,
      fontStyle: "normal",
      maxWidth: width,
    });
    return isTruncated;
  }, [file.name, width]);

  return (
    <>
      <Group y={y}>
        <Rect ref={tooltipNode} y={-7} width={maxFileNameWidth - 30} height={24} cornerRadius={6} fill="#F6F7FB" />
        <Text
          x={10}
          text={file.name}
          fill={TEXT_COLOR}
          fontFamily={FONT_FAMILY}
          fontSize={FONT_SIZE}
          letterSpacing={0.1871}
          wrap="none"
          ellipsis
          width={width}
          listening={false}
        />
        {isImage && <VisibilityButton y={-7} controller={controller} file={file} x={maxFileNameWidth - 56} />}
        <DownloadButton y={-7} file={file} x={maxFileNameWidth - 24} />
      </Group>
      <KonvaTooltip text={file.name} nodeRef={tooltipNode} offset={8} disabled={!isTruncated} />
    </>
  );
});

FileRow.displayName = "FileRow";
